import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./SelectFromCategories.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

import Product_Card from "../Common-Component/Product_Card/Product_Card";
import Popular_Product_Card from "../Common-Component/Popular_Product_Card/Popular_Product_Card";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Context } from "../../utils/context";

import { Category, Products } from "../../utils/apis/Product/Product";
library.add(fas);

const SelectFromCategories = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [numToShow, setNumToShow] = useState(4); // State to track number of cards to show
  const [showAll, setShowAll] = useState(false); // State to track whether to show all cards or not
  const navRef = useRef(null);
  const navigate = useNavigate();

  const { id } = useParams();


  const toggleShowAll = () => {
    setShowAll(!showAll);
    setNumToShow(showAll ? 8 : products.length);
    if (showAll) {
      // If currently showing all, reduce the number of rows displayed
      setNumToShow(4);
    } else {
      // If currently not showing all, show all rows
      setNumToShow(category.length);
    }
  };

  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
  
  const [category, setCategory] = useState([]);
  const getCategory = async () => {
    setShimmerLoader(true);
    const res = await Category();
    if (res?.success) {
      getProduct(id);
      setCategory(res.data);
      setShimmerLoader(false);
    }
  };

  const [products, setProducts] = useState([]);

  const [activeTab, setActiveTab] = useState(0);
  const getProduct = async (id) => {
    const res = await Products(id);
    if (res?.success) {
      setProducts(res?.data?.data);
      setActiveTab(id);
    }
  };

  const handleNext = async (id) => {
    navigate(`/select-from-category/${id}`);
  };

  useEffect(() => {
    getCategory();
  }, [id]);

  return (
    <section className="select-categories">
      <Container>
        <div className="mb-4">
          <h2 className="title">All Category</h2>
        </div>
        {/* tab */}
        <Tab.Container id="left-tabs-example" defaultActiveKey={id}>
          <div className="me-0 ms-0 ">
            <Nav variant="pills" className="">
              <Swiper
                slidesPerView={1}
                spaceBetween={30}
                navigation={true}
                modules={[Navigation, Pagination]}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  575: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },

                  768: {
                    slidesPerView: 3.5,
                    spaceBetween: 10,
                  },
                  992: {
                    slidesPerView: 4.5,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 5.5,
                    spaceBetween: 10,
                  },
                  1400: {
                    slidesPerView: 6.5,
                    spaceBetween: 10,
                  },
                }}
                className=""
              >
                {category?.map((slide, index) => (
                  <SwiperSlide
                    key={index}
                    className="product-slide"
                    onClick={() => {
                      handleNext(slide?.id);
                    }}
                  >
                    <Nav.Item>
                      <Nav.Link
                        className={activeTab == slide?.id ? "active" : ""}
                        onClick={() => getProduct(slide?.id)}
                      >
                        <Popular_Product_Card
                          className="product-image"
                          content={slide?.name}
                          image={IMG_URL + slide?.image}
                          imgClassName="category-image"
                        />
                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Nav>
          </div>

          {category?.map((slide, index) => (
            <Tab.Content key={index}>
              <Tab.Pane eventKey={slide?.id}>
                <div className="desktop_view_product_category_slider">
                  <Row>
                    {products?.length > 0 ? (
                      products.slice(0, numToShow).map((product, index) => (
                        <Col key={index} xxl={3} xl={3} lg={4} md={6} sm={6}>
                          <Product_Card
                            image={IMG_URL + product?.image1}
                            text={product?.name}
                            product_id={product?.id}
                            subText={product?.short_description}
                            price={product?.variants[0]?.s_price}
                            variant_id={product?.variants[0]?.id}
                          />
                        </Col>
                      ))
                    ) : (
                      <div className="noprodiv">
                        <p>No Product Available</p>
                      </div>
                    )}
                  </Row>
                </div>

                {/* desktop_view_product_category_slider end */}

                {/* mobile_view_product_category_slider start */}

                <div className="mobile_view_product_category_slider">
                  <Swiper
                    className="select-categories-slider mySwiper"
                    modules={[Pagination]}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                      },
                      420: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                      },
                      486: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                      },
                      576: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                      },
                      992: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                      },
                    }}
                  >
                    {products?.length > 0 ? (
                      products.slice(0, numToShow).map((category, index) => (
                        <SwiperSlide>
                          <Product_Card
                            image={IMG_URL + category?.image1}
                            text={category?.name}
                            product_id={category?.id}
                            subText={category?.short_description}
                            price={category?.variants[0]?.s_price}
                            variant_id={category?.variants[0]?.variant_id}
                          />
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="noprodiv">
                        <p>No Product Available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Tab.Pane>
            </Tab.Content>
          ))}
        </Tab.Container>

        {(numToShow < products.length || showAll) && (
          <div className="view-all mb-5" onClick={toggleShowAll}>
            <p>{showAll ? "View Less" : "View All"}</p>
          </div>
        )}
      </Container>
    </section>
  );
};

export default SelectFromCategories;
